import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Card, CardContent } from '@mui/material'
import Tag from './Tag'
import { formatDateShort } from '../utils/format'
import { colors } from '../styles/theme'

const BlogCard = ({ post, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      whileHover={{ y: -8, transition: { duration: 0.2 } }}
    >
      <Link to={`/blog/${post.slug}`} className="block group">
        <Card
          sx={{
            backgroundColor: colors.bgInput,
            color: colors.textPrimary,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            border: `1px solid ${colors.borderAccent}`,
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: 'var(--shadow-card-hover)',
              borderColor: colors.borderAccentHover,
            },
          }}
        >
          {post.coverImage ? (
            <div className="h-48 overflow-hidden">
              <img
                src={post.coverImage}
                alt={post.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
          ) : (
            <div className="h-32 bg-gradient-to-br from-purple/20 via-slate/40 to-cyan/20 flex items-center justify-center">
              <span className="text-6xl font-bold font-mono text-cyan/20">
                {post.title.charAt(0)}
              </span>
            </div>
          )}

          <CardContent sx={{ flexGrow: 1, p: 3 }}>
            <div className="flex flex-wrap gap-2 mb-3">
              {post.tags.slice(0, 3).map(tag => (
                <Tag key={tag} tag={tag} size="small" />
              ))}
            </div>

            <h3 className="text-lg font-bold text-off-white mb-2 line-clamp-2">
              {post.title}
            </h3>

            <p className="text-sm text-gray-400 mb-4 line-clamp-3">
              {post.excerpt}
            </p>

            <div className="text-xs text-gray-500">
              {formatDateShort(post.publishedAt || post.createdAt)}
            </div>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  )
}

export default BlogCard
